import classnames from "classnames"
import moment from "moment"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"

const Timeago = ({ date, className }) => {
  return (
    <span className={classnames("Timeago", className)}>
      {moment(date).fromNow()}
    </span>
  )
}

Timeago.displayName = "Timeago"

export default withTranslate(Timeago)
